<template>
  <NuxtLayout>
    <div class="error-page">
      <Hero :content="false">
        <template #image>
          <ElementsImage v-if="data?.hero?.image" v-bind="data.hero.image" />
        </template>
      </Hero>

      <ElementsContainer>
        <ElementsError :title="data?.hero?.title" :description="data?.hero?.description" :link="data?.button" />
      </ElementsContainer>
    </div>
  </NuxtLayout>
</template>

<script setup lang="ts">
  import fetchApi from "~/utils/fetchApi"

  const { data: responseData } = await useAsyncData("error-page", () =>
    fetchApi<any>("error-page", {
      wrappedByKey: "data",
      populate: {
        hero: { populate: "*" },
        button: { populate: "*" }
      }
    })
  )

  const data = computed(() => responseData.value || {})

  const { t } = useI18n()

  useSeoMeta({
    title: () => data.value?.hero?.title || t("menu.error", "Error"),
    description: () => data.value?.hero?.description || ""
  })
</script>

<style scoped lang="scss"></style>
